import {useLocation} from "react-router-dom";
import {kSystemDrawerMainNavigationItems} from "../../constants/navigation";
import SystemAppSideBarNavigationItem from "../items/SystemAppSideBarNavigationItem";
import {useEffect, useState} from "react";
import SystemAppSideBarHeader from "../headers/SystemAppSideBarHeader";

export default function SystemAppSideBar() {
    // Used in application screens to display left side navigation bar

    // PROPERTIES
    const [isNarrowScreen, setIsNarrowScreen] = useState(false);
    const [isCollapsed, setIsCollapsed] = useState(false);
    const location = useLocation();
    const currentPath = location.pathname;

    // HOOKS
    // ---- At rendering : Add event listener on screen size
    useEffect(() => {
        updateIsNarrowScreen();
        window.addEventListener("resize", updateIsNarrowScreen);
        return () => window.removeEventListener("resize", updateIsNarrowScreen);
    }, []);

    // BUILD
    return (
        <div className={`bg-backgroundLight1 h-[100vh] border-r-[1px] border-greyLight3 flex flex-col
                           transition-all duration-300 ease-in-out
                           ${displayCollapseBar() ? "w-[104px] min-w-[104px]" : "w-[216px] min-w-[216px]"}`}>
            <SystemAppSideBarHeader isCollapsed={isCollapsed}
                                    setIsCollapsed={setIsCollapsed}
                                    isNarrowScreen={isNarrowScreen} />
            <div className={"overflow-auto grow w-full flex flex-col"}>
                {kSystemDrawerMainNavigationItems.map((item, index) => (
                    <SystemAppSideBarNavigationItem key={index}
                                                    item={item}
                                                    isNarrowScreen={isNarrowScreen}
                                                    isCollapsed={isCollapsed}
                                                    isActive={currentPath === item.route} />
                ))}
            </div>
        </div>
    );

    // METHODS
    // ---- UI : Update state for narrow screen
    function updateIsNarrowScreen() {
        setIsNarrowScreen(window.innerWidth <= 800);
    }

    // ---- UI : Display collapsed version of the bar
    function displayCollapseBar() {
        return isCollapsed || isNarrowScreen
    }
}